import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { cn } from '../../utility/base';
import { buttonVariants } from '@playcastdotio/Shadcn';

const SINGULAR_BASE_URL = 'https://umbr.sng.link/Dqpwd/4wv6/2fla';

export const StfAttribution = () => {
  const [searchParams] = useSearchParams();
  const gclid = searchParams.get('gclid');

  const singularUrl = useMemo(() => {
    if (!gclid) return SINGULAR_BASE_URL;
    const url = new URL(SINGULAR_BASE_URL);
    url.searchParams.set('pcid', gclid);
    return url.toString();
  }, [gclid]);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className='bg-black text-white m-0 h-auto w-full p-0 min-h-screen'>
      <div className='container mx-auto h-auto w-full px-8 py-12 max-w-4xl'>
        <section className='flex flex-col items-center gap-8'>
          {/* App Icon and Title Section */}
          <div className='flex flex-col items-center gap-4 w-full'>
            <img 
              src='/stf-attribution/stf-icon.png' 
              alt='Super Tiny Football Icon' 
              className='w-32 h-32 rounded-3xl shadow-lg'
            />
            <div className='text-center'>
              <h1 className='text-4xl font-bold mb-2 text-white'>Super Tiny Football</h1>
              <p className='text-xl text-gray-400'>SMT Games</p>
              <div className='flex items-center justify-center gap-2 mt-3'>
                <span className='text-sm text-gray-400'>4.6★</span>
                <span className='text-sm text-gray-600'>•</span>
                <span className='text-sm text-gray-400'>100K+ Downloads</span>
                <span className='text-sm text-gray-600'>•</span>
                <span className='text-sm text-gray-400'>Everyone</span>
              </div>
            </div>
          </div>

          {/* Download Button */}
          <a 
            href={singularUrl}
            target='_blank'
            rel='noopener noreferrer'
            className={cn(
              buttonVariants(), 
              'w-full max-w-md rounded-xl text-lg font-semibold py-6 shadow-md hover:shadow-lg transition-all',
              'bg-amber-400 hover:bg-amber-500 text-black'
            )}
          >
            Play Super Tiny Football
          </a>

          {/* Screenshot Section */}
          <div className='w-full mt-4'>
            <img 
              src='/stf-attribution/stf-main-image.png' 
              alt='Super Tiny Football Gameplay' 
              className='w-full rounded-2xl shadow-xl'
            />
          </div>

          {/* Additional Info */}
          <div className='text-center mt-4'>
            <p className='text-sm text-gray-400'>
              A free-to-play mobile football game brought to you by SMT,
            </p>
            <p className='text-sm text-gray-300 font-semibold'>
              The Yellow First Down Line Company®
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};
